import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import ReactDOM from 'react-dom';
import { reducers } from './reducers/index';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import App from './App';
import {Provider} from "react-redux";
import {BrowserRouter} from 'react-router-dom';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';
import * as settings from './services/settings';

const appRoot = document.getElementById('translationToolApp');

const client = new ApolloClient({
	uri: settings.getGraphql(),
	onError: ({ graphQLErrors, networkError, operation, forward }) => {
		console.log(graphQLErrors)
	}
});

if(appRoot) {
	const store = createStore(
		reducers,
		composeWithDevTools(applyMiddleware(thunk))
	);

	ReactDOM.render(
		<ApolloProvider client={client}>
			<Provider store={store}>
				<BrowserRouter>
					<App/>
				</BrowserRouter>
			</Provider>
		</ApolloProvider>,
		appRoot
	);
}



// WEBPACK FOOTER //
// ./React/src/index.js